module.exports = __webpack_public_path__ + "static/desktop-053fd0cd987a64fcff915fe961ce679a.png";